import React, {useState, useContext} from 'react';

import './ShoppingCartSlideout.scss';
import ProductCart from '../ProductCart/ProductCart.en';
import IconClose from '../../../../static/images/icons/close--black.svg';
import { CartContext } from '../../../../context/CartContext';
import {CartController} from "../../../../helpers/CartController";

const ShoppingCartSlideoutEn = ({ setShowShoppingCartEn }) => {
  const goToCheckout = () => {
    let url = `${process.env.GATSBY_WORDPRESS_URL}/checkout/${CartController.getCartQueryString('en')}`;
    window.open(url, '_blank').focus();
    CartController.dropAll();
  }
  const closeSoppingCart = () => setShowShoppingCartEn((prev) => !prev);
  const cart = CartController.getOrCreateCartIfNoExits('en');
  const total = cart.items.reduce((ac, el) => (el.priceNumber * el.quantity) + ac, 0 );
  const [cart_, setCart] = useState([]);
  const {cartCount, setCartCountEn,} = useContext(CartContext);
  const updateCountDelete = () => {
    setCartCountEn(CartController.getOrCreateCartIfNoExits('en').items.length);
  }
  return (
    <div
      id="shopping-cart-slideout"
      onClick={closeSoppingCart}
      aria-hidden="true"
      role="button"
      tabIndex="0"
    >
      <aside
        className="shopping-cart"
        onClick={(e) => e.stopPropagation()}
        aria-hidden="true"
      >
        <button
          className="btn-close"
          aria-label="Cerrar carrito"
          onClick={closeSoppingCart}
        >
          <img src={IconClose} alt="Cerrar" />
        </button>
        <h2>My bag</h2>
        <div className="products-cart-box">
          {cart.items.map((v, index) => (
            <ProductCart key={index} item={v} setCart={setCart} updateCount={updateCountDelete}/>
          ))}
        </div>

        <div className="totals">
          <span className="text">
            Total
          </span>
          <span id="cart__total_amount" className="amount">
            S/. {total}
          </span>
        </div>

        <button className="btn btn--primary btn-pay" type="button" onClick={goToCheckout} disabled={cart.items.length === 0}>
          Pay
        </button>
      </aside>
    </div>
  );
};

export default ShoppingCartSlideoutEn;
